import React from 'react';
import { callRates, getAllProviderCall } from '../../api-services';
import moment from 'moment';
import Country from '../../components/Country';
import { createTable } from '@tanstack/react-table';
import TableManager from '../../components/TableManager';
import { useState } from 'react';
import CallRateUpload from './Modals/CallRateUpload';
import { useQuery } from 'react-query';
import CallUpdateMargin from './Modals/CallUpdateMargin';
import { Country as GlobalCountries } from 'country-state-city';

const table = createTable();

const DateFilterTypes = [
  { label: 'Today', value: 'Today' },
  { label: 'Yesterday', value: 'Yesterday' },
  { label: 'Last 7 Days', value: 'Last 7 Days' },
  { label: 'Last 30 Days', value: 'Last 30 Days' },
  { label: 'This Month', value: 'This Month' },
  { label: 'Last Month', value: 'Last Month' },
  { label: 'Custom', value: 'Custom' },
];

const currencyOptions = [
  { label: 'EURO', value: 'EURO' },
  { label: 'XOF', value: 'XOF' },
  { label: 'USD', value: 'USD' },
  { label: 'GBP', value: 'GBP' },
  { label: 'NGN', value: 'NGN' },
];

const initialValues = {
  filter: [
    {
      currency: '',
      a_filter_type: '',
      placeholder: 'Select Currency...',
      type: 'select',
      shouldFilterOptionDisabled: true,
      selectOptions: currencyOptions,
      label: 'Currency',
    },

    {
      country: '',
      a_filter_type: '',
      placeholder: 'Select Country...',
      type: 'select',
      shouldFilterOptionDisabled: true,
      selectOptions: GlobalCountries?.getAllCountries(),
      label: 'Country',
    },

    {
      date: {
        from: '',
        to: '',
      },
      a_filter_type: '',
      placeholder: 'Custom Date Range...',
      type: 'date',
      shouldFilterOptionDisabled: false,
      filterOptions: DateFilterTypes,
      selectOptions: [],
      label: 'Date',
    },
  ],
};
const Call = () => {
  const [isUpload, setUploadRate] = useState(false);
  const [isUpdate, setUpdateMargin] = useState(false);
  const [filters, setFilters] = useState([]);
  const [openFilter, setOpenFilter] = useState(false);
  const { data: AllProvidersCall } = useQuery(
    'getAllProviderCall',
    getAllProviderCall,
    {
      select: (data) => data?.data?.data,
    },
  );

  const columns = [
    table.createDataColumn('created_at', {
      id: 'created_at',
      header: 'Date',
      cell: (props) => moment(props.getValue()).format('YYYY-MM-DD: HH:mm:ss'),
      isSortable: true,
    }),

    table.createDataColumn('alpha2code', {
      id: 'alpha2code',
      header: 'Country',
      textAlign: 'left',
      cell: (props) => <Country isoCode={props.getValue()} />,
    }),
    table.createDataColumn('destination', {
      id: 'destination',
      header: 'Destination',
      textAlign: 'left',
    }),
    table.createDataColumn('rate', {
      id: 'rate',
      header: 'Buy rate',
      isSortable: true,
    }),
    table.createDataColumn('sale_rate', {
      id: 'sale_rate',
      header: 'Sell rate',
      isSortable: true,
    }),
    table.createDataColumn('currency', {
      id: 'currency',
      header: 'Currency',
    }),
    table.createDataColumn('type', {
      id: 'type',
      header: 'Type',

      cell: (props) => (props.getValue() === 'M' ? 'Mobile' : 'Landline'),
    }),
    table.createDataColumn('status', {
      id: 'status',
      header: 'Status',
      cell: (props) =>
        props.getValue() ? (
          <a className="text-success" href="#">
            Activated
          </a>
        ) : (
          <a className="text-danger" href="#">
            Deactivated
          </a>
        ),
    }),
  ];

  const handleUploadRates = () => {
    setUploadRate(true);
  };
  const handleUpdateMargin = () => {
    setUpdateMargin(true);
  };

  return (
    <>
      <TableManager
        table={table}
        columns={columns}
        filter={filters}
        fetcherKey="callRates"
        fetcherFn={callRates}
        title="Call Rates"
        shouldUpload={true}
        uploadCtaFunction={handleUploadRates}
        uploadCtaLabel="Upload Rates"
        updateMargin={true}
        updateMarginCtaFunction={handleUpdateMargin}
        updateMarginCtaLabel="Update Margins"
        shouldFilter={true}
        openFilter={openFilter}
        setOpenFilter={setOpenFilter}
        initialValues={initialValues}
        setFilters={setFilters}
        filters={filters}
      />

      {isUpload && (
        <CallRateUpload
          setOpenModal={setUploadRate}
          openModal={isUpload}
          AllProvidersCall={AllProvidersCall}
        />
      )}
      {isUpdate && (
        <CallUpdateMargin
          setOpenModal={setUpdateMargin}
          openModal={isUpdate}
          AllProvidersCall={AllProvidersCall}
        />
      )}
    </>
  );
};

export default Call;
